import React, { useEffect, useState, useContext } from "react";
import { useParams, useHistory } from "react-router";
import { Button, TextField, Typography } from "@mui/material";

import Loader from "../../components/Loader";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import parseRequirements from "../../utils/parseRequirements";

import Swal from "sweetalert2";
import Toast from "../../utils/Toast";

import useGift from "../../queries/gift/getGift";
import useCompanies from "../../queries/gift/companies";
import useCreateAudit from "../../mutation/audit/createAudit";
import { AuthContext } from "../../utils/userProvider";
import {
  FormPageShell,
  FormPageCard,
  FormPageHeader,
  FormActions,
} from "../../components/ListPage";

const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  description: yup.string().required("Description is required"),
  code: yup.string().required("Promo Code is required"),
  company: yup.number().required("Company is required"),
  /* counter: yup.number().min(0, "Counter must be positive"), */
});

const EditGift = (props) => {
  const { id } = useParams();
  const history = useHistory();
  const { authState, setAuthState } = useContext(AuthContext);
  const [response, resetGift] = useGift(id);
  const [companyResponse, reset] = useCompanies();
  const [companyOptions, setCompanyOptions] = useState([]);

  const [defaultCompanyValue, setDefaultCompanyValue] = useState();
  const [auditResponse, setAuditData] = useCreateAudit();
  const [currentData, setCurrentData] = useState();
  const [snapshotCurrent, setSnapshotCurrent] = useState({});

  useEffect(() => {
    if (response.data && companyResponse.data) {
      console.log(response.data);
      setSnapshotCurrent(response.data);
      setCurrentData(response.data.id);
      setValue("name", response.data.name);
      setValue("description", response.data.description);
      setValue("code", response.data.code);
      setValue("counter", response.data.counter);
      setCompanyOptions(parseRequirements(companyResponse.data));
      let selected_company = parseRequirements(companyResponse.data).find(
        (x) => x.value == response.data.company
      );
      if (selected_company) {
        setDefaultCompanyValue(selected_company);
        setValue("company", response.data.company);
      }
    }
  }, [response, companyResponse]);

  const { control, register, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const goBack = () => {
    window.location.href = "/dashboard/gifts";
  };

  const onSubmit = (values) => {
    Swal.fire({
      title: "Create Updates",
      html: `<h4>Please provide a description before submitting your changes</h4>
      <textarea maxlength="100" type="text" id="actionDescription" class="swal2-input" placeholder="Description" font-size=18px style="height:auto!important" rows=5>`,
      confirmButtonText: "Confirm",
      focusConfirm: false,
      preConfirm: () => {
        const actionDescription =
          Swal.getPopup().querySelector("#actionDescription").value;
        if (!actionDescription) {
          Swal.showValidationMessage(`Please enter description`);
        }
        return {
          actionDescription: actionDescription,
          newData: values,
          snapshotCurrent: snapshotCurrent,
          currentData: currentData,
          type: "gift",
          action: "update",
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setAuditData(result.value);
      }
    });
    if (values.counter == "") {
      values.counter = response.data.counter;
    }
    //setData(values);
  };

  useEffect(() => {
    try {
      if (auditResponse.data) {
        Toast.fire({
          icon: "success",
          title: "Gift Updation Audit Created",
        });
        history.push("/dashboard/gifts");
      } else if (auditResponse.error) {
        let data = auditResponse.errorMessage.response.data;
        if (data) {
          let messageData = data.message;
          let message = messageData.message;

          Swal.fire({
            icon: "error",
            title: "Error",
            text: message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: auditResponse.error.message,
          });
        }
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message,
      });
    }
  }, [auditResponse]);

  const companyChange = (value) => {
    if (value != null) {
      setValue("company", value.value);
    }
  };

  const renderContent = () => {
    return (
      <FormPageShell>
        <form noValidate onSubmit={handleSubmit(onSubmit)}>
          <FormPageCard>
            <FormPageHeader
              title={
                authState.editAccess ? "Edit Gift" : "View Gift"
              }
              onBack={goBack}
            />
            <TextField
              name="name"
              margin="normal"
              fullWidth
              label="Name*"
              variant="outlined"
              inputRef={register}
              error={errors.name != null}
              helperText={errors.name != null ? errors.name.message : null}
              disabled={auditResponse.loading || !authState.editAccess}
            />
            <TextField
              name="description"
              margin="normal"
              fullWidth
              multiline={true}
              label="Description"
              variant="outlined"
              inputRef={register}
              error={errors.description != null}
              helperText={
                errors.description != null
                  ? errors.description.message
                  : null
              }
              disabled={auditResponse.loading || !authState.editAccess}
            />
            <TextField
              name="code"
              margin="normal"
              fullWidth
              label="Promo Code*"
              variant="outlined"
              inputRef={register}
              error={errors.code != null}
              helperText={errors.code != null ? errors.code.message : null}
              disabled={auditResponse.loading || !authState.editAccess}
            />

            <TextField
              name="counter"
              margin="normal"
              fullWidth
              multiline={true}
              label="Usage Count"
              variant="outlined"
              inputRef={register}
              error={errors.counter != null}
              helperText={
                errors.counter != null ? errors.counter.message : null
              }
              disabled={auditResponse.loading || !authState.editAccess}
            />
            <Typography sx={{ fontSize: 16, fontWeight: "bold", mt: 1 }}>
              Company (from RMS Cloud)
            </Typography>
            {companyOptions.length > 0 && (
              <div>
                <Controller
                  name="company"
                  defaultValue={defaultCompanyValue}
                  control={control}
                  render={({ ...props }) => {
                    return (
                      <Select
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            borderColor: errors.company
                              ? "red"
                              : provided.borderColor,
                          }),
                        }}
                        defaultValue={defaultCompanyValue}
                        options={companyOptions}
                        onChange={companyChange}
                        isDisabled={
                          auditResponse.loading || !authState.editAccess
                        }
                      />
                    );
                  }}
                />
                {errors.company && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ mx: 1.75, mt: 0.375, display: "block" }}
                  >
                    {errors.company.message}
                  </Typography>
                )}
              </div>
            )}
          </FormPageCard>
          {authState.editAccess && (
            <FormPageCard sx={{ mt: 2 }}>
              <FormActions>
                <Button
                  type="submit"
                  size="large"
                  variant="contained"
                  color="primary"
                  disabled={auditResponse.loading}
                >
                  Submit
                </Button>
              </FormActions>
            </FormPageCard>
          )}
        </form>
      </FormPageShell>
    );
  };

  return (
    <div>
      {response.loading && companyResponse.loading && (
        <FormPageCard>
          <Loader />
        </FormPageCard>
      )}
      {!response.loading && !companyResponse.loading && renderContent()}
    </div>
  );
};

export default EditGift;
